<template>
    <div>
        <div style="background: white;">
            <el-image :src="imgUrl" class="solution-img" alt="解决方案"></el-image>
        </div>
        <div class="solution-menu">
            <el-tabs v-model="activeName">
                <el-tab-pane label="煤矿" name="first">
                    <div class="index-div-content product-info-div product-info-div-no-padding">
                        <el-row :gutter="200"  type="flex" class="product-info-div-flex">

                            <el-col :xs="24" :sm="10">
                                <div class="product-image-zoom">
                                    <div class='magnify'>
                                        <div class='large'></div>
                                        <img src="../../assets/unifun/solution/2.png" width="100%" class='small' alt="">
                                    </div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="14">
                                <div class="solution-content">
                                    <router-link to='/solution/colliery-corridor'><h3 class="font-24 product-header">输煤廊道机器人智能巡检解决方案</h3></router-link>
                                    <p class="product-content">
                                        华方智能煤炭行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对煤炭行业场景的全方位自主巡检和实时监控。
                                    </p>
                                    <router-link to='/solution/colliery-corridor'>
                                        <el-button type="primary" class="button " style="width: 110px">
                                            查看解决方案
                                        </el-button>
                                    </router-link>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="电力" name="second">
                    <div class="index-div-content product-info-div product-info-div-no-padding">
                        <el-row :gutter="200"  type="flex" class="product-info-div-flex">

                            <el-col :xs="24" :sm="10">
                                <div class="product-image-zoom">
                                    <div class='magnify'>
                                        <div class='large'></div>
                                        <img src="../../assets/unifun/solution/4.png" width="100%" class='small' alt="">
                                    </div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="14">
                                <div class="solution-content">
                                    <router-link to='/solution/electricity'><h3 class="font-24 product-header">变电站变电所机器人智能巡检解决方案</h3></router-link>
                                    <p class="product-content">
                                        华方智能电力巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对变电站场景的全方位自主巡检和实时监控。
                                    </p>
                                    <router-link to='/solution/electricity'>
                                        <el-button type="primary" class="button " style="width: 110px">
                                            查看解决方案
                                        </el-button>
                                    </router-link>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="水泥" name="third">
                    <div class="index-div-content product-info-div product-info-div-no-padding">
                        <el-row :gutter="200"  type="flex" class="product-info-div-flex">

                            <el-col :xs="24" :sm="10">
                                <div class="product-image-zoom">
                                    <div class='magnify'>
                                        <div class='large'></div>
                                        <img src="../../assets/unifun/solution/11.png" width="100%" class='small'
                                             alt="">
                                    </div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="14">
                                <div class="solution-content">
                                    <router-link to='/solution/cement'> <h3 class="font-24 product-header">水泥厂输料带机器人智能巡检解决方案</h3></router-link>
                                    <p class="product-content">
                                        华方智能水泥行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对水泥行业场景的全方位自主巡检和实时监控。
                                    </p>
                                    <router-link to='/solution/cement'>
                                        <el-button type="primary" class="button " style="width: 110px">
                                            查看解决方案
                                        </el-button>
                                    </router-link>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="钢铁" name="fourth">
                    <div class="index-div-content product-info-div product-info-div-no-padding">
                        <el-row  :gutter="200"  type="flex"   class="product-info-div-flex">

                            <el-col :xs="24" :sm="10">
                                <div class="product-image-zoom">
                                    <div class='magnify'>
                                        <div class='large'></div>
                                        <img src="../../assets/unifun/solution/24.png" width="100%" class='small'
                                             alt="">
                                    </div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="14">
                                <div class="solution-content">
                                    <router-link to='/solution/steel'> <h3 class="font-24 product-header">钢铁厂输料皮带机机器人智能巡检解决方案</h3></router-link>
                                    <p class="product-content">
                                        华方智能钢铁行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对钢铁行业场景的全方位自主巡检和实时监控。                            </p>
                                    <router-link to='/solution/steel'>
                                        <el-button type="primary" class="button " style="width: 110px">
                                            查看解决方案
                                        </el-button>
                                    </router-link>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="港口" name="five">
                    <div class="index-div-content product-info-div product-info-div-no-padding">
                        <el-row :gutter="200"  type="flex" class="product-info-div-flex">

                            <el-col :xs="24" :sm="10">
                                <div class="product-image-zoom">
                                    <div class='magnify'>
                                        <div class='large'></div>
                                        <img src="../../assets/unifun/solution/15.png" width="100%" class='small'
                                             alt="">
                                    </div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="14">
                                <div class="solution-content">
                                    <router-link to='/solution/port'><h3 class="font-24 product-header">港口输料皮带机智能机器人巡检解决方案</h3></router-link>
                                    <p class="product-content">
                                        华方智能港口行业巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对港口行业场景的全方位自主巡检和实时监控。                             </p>
                                    <router-link to='/solution/port'>
                                        <el-button type="primary" class="button " style="width: 110px">
                                            查看解决方案
                                        </el-button>
                                    </router-link>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>


    </div>
</template>

<script>
    export default {
        name: "index",
        data() {
            return {
                activeName: 'first',
                imgUrlList:{
                    first:require('../../assets/unifun/solution/1.png') ,
                    second:require('../../assets/unifun/solution/16.png'),
                    third:require('../../assets/unifun/solution/17.png'),
                    five:require('../../assets/unifun/solution/18.png'),
                    fourth:require('../../assets/unifun/solution/23.png')
                },
                imgUrl:require('../../assets/unifun/solution/1.png')
            }
        },
        mounted(){
            if(this.$route.query.name){
                this.activeName = this.$route.query.name
                this.imgUrl = this.imgUrlList[this.$route.query.name]
            }else{
                this.activeName='first',
                    this.imgUrl = require('../../assets/unifun/solution/1.png')
            }
        },
        watch:{
            activeName(){
                this.imgUrl = this.imgUrlList[this.activeName]
            }
        }
    }
</script>

<style lang="scss">

    .solution-content {
        margin-top: 30px;
        width: 90%;

    }

    .solution-menu {
        .el-tabs__nav-scroll {
            display: flex !important;

            .el-tabs__nav {
                margin: 0 auto !important;

                .el-tabs__item {
                    width: 200px;
                    height: 40px;
                    background: #FFFFFF;
                    opacity: 1;
                    text-align: center;
                    border-left: 1px solid #CCCCCC;

                    &.is-active {
                        background: #005DAB;
                        color: white;
                    }
                }

                .el-tabs__active-bar {
                    background: transparent;
                }

                #tab-five {
                    border-right: 1px solid #CCCCCC;
                }

            }


        }

        .el-tabs__header {
            background: white;
        }

        .el-tabs__nav-wrap::after {
            background: transparent;
        }
    }


</style>